import React from 'react';
import { StyledContainer, Spacing } from './styles';
import { GoogleIcon, OutlookIcon } from '../../../assets/img';
import { Button } from '../../atoms';
import { ILoginOAuth } from './types';

const LoginOAuth: React.FunctionComponent<ILoginOAuth> = ({ signInWithOAuth }) => {
    return (
        <StyledContainer>
            <Button type="OAuth" iconSrc={GoogleIcon} onClick={() => signInWithOAuth('google')}>
                Continue with Google
            </Button>
            <Spacing />
            <Button type="OAuth" iconSrc={OutlookIcon} onClick={() => signInWithOAuth('outlook')}>
                Continue with Outlook
            </Button>
        </StyledContainer>
    );
};

export default LoginOAuth;
